var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('base-button',{staticClass:"btn-twitter btn-second",attrs:{"block":""},on:{"click":function($event){return _vm.initAssign()}}},[_vm._v(" "+_vm._s(_vm.deliveryLogistic ? _vm.deliveryLogistic.toUpperCase() : 'Assign Logistic')+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }